import React from "react";
import PropTypes from "prop-types";
import { Flex, FlexItem, Badge, Popover } from "orcs-design-system";

const BadgesDisplay = ({ badgeConfig }) => {
  if (!badgeConfig || badgeConfig.length === 0) {
    return null;
  }

  return (
    <Flex gap="xs" flexWrap="wrap">
      {badgeConfig.map(
        (badge) =>
          badge.label && (
            <FlexItem flex="0 0 auto" key={badge.id}>
              {badge.popoverContent ? (
                <Popover
                  direction="top"
                  width="fit-content"
                  text={badge.popoverContent}
                >
                  <Badge variant={badge.color || "default"}>
                    {badge.label}
                  </Badge>
                </Popover>
              ) : (
                <Badge variant={badge.color || "default"}>{badge.label}</Badge>
              )}
            </FlexItem>
          )
      )}
    </Flex>
  );
};

BadgesDisplay.propTypes = {
  badgeConfig: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string,
      color: PropTypes.string,
      popoverContent: PropTypes.node,
    })
  ),
};

export default BadgesDisplay;
